import reqwest from 'reqwest'
import localStorage from '@/utils/localStorage'
export default {
	data() {
		return {
			host: 'https://xyd.568lao.com', 
			uploaddata: {},
			imageHost: '',
			appId: '',
			version: '1.0.0',
			platform: 'PC',
			codeLogin: 0,
			userInfo:{
				token:0,
				merchantId:''
			}
		}
	},
	methods: {
		request(config) {
			let that = this
			
			let vueVersion = this.version;
			let localVueVersion = localStorage.getItem('vueVersion');
			
			config.data.version = this.version
			config.data.timestamp = Math.round(new Date().getTime() / 1000)
			let data = {}
			let sign = ''
			var sdic = Object.keys(config.data).sort()
			for (let ki in sdic) {
				sign += sdic[ki]
				data[sdic[ki]] = config.data[sdic[ki]]
			}
		
			if (!config.url.startsWith('http')) {
				config.url = this.host + config.url
			}
			reqwest({
				url: config.url,
				type: 'json',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				method: 'POST',
				crossOrigin: true,
				data: JSON.stringify(data),
				success: function(response) {
					// console.log(response)
					if (response.code == 401) {
						that.codeLogin = 1
						that.$message({
							showClose: true,
							message: response.message,
							type: 'success'
						});
						localStorage.removeItem('userInfo')
						location.reload();
					} else {
						config.success(response)
					}
				},
				error: function() {
					// config.error()
				},
				complete: function() {

				}
			})
		},
		requestGET(config) {
			reqwest({
				url: config.url,
				type: 'json',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				method: 'GET',
				success: function(response) {
					config.success(response)
				},
				error: function() {
					// config.error()
				},
				complete: function() {

				}
			})
		},
		// 下载文件
		Download(url, name) {
			console.log(url, name)
			let link = document.createElement('a')
			link.style.display = 'none'
			link.target = '_new'
			link.download = name
			link.href = url
			link.click();
		},
	}
}



// WEBPACK FOOTER //
// ./src/mixins/index.js